export default __webpack_public_path__ + "static/media/February2013.b78b6099.png";